import { render, staticRenderFns } from "./VTextAreaWithValidation.vue?vue&type=template&id=076bef2d&"
import script from "./VTextAreaWithValidation.vue?vue&type=script&lang=js&"
export * from "./VTextAreaWithValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
